<template>
    <div class="box p-4">
        <div v-if="model.publishDate || model.tag" class="d-flex align-items-center smaller-font mb-3">
            <span v-if="model.tag" class="tag mr-2">{{ model.tag }}</span>
            <span v-if="model.publishDate">{{ model.publishDate }}</span>
        </div>
        <div v-if="model.report" class="report-body" v-html="model.report"></div>
    </div>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true,
                default: () => ({
                    report: null,
                    publishDate: null,
                    tag: null
                })
            }
        },
    };
</script>